import React, { useEffect, useRef, useState } from 'react'

import { toast } from 'react-toastify';
import { CallApi, CommonModal } from '../../../Components/common/CommonFunctions';
import Select from 'react-select';
import { Container, Row, Col, Modal, Form, Button, Table, Accordion, Badge, Dropdown } from 'react-bootstrap';
import { ReactComponent as Ovicon } from "../../../assets/images/icon_svg/shipment.svg";
import { ReactComponent as Tkicon } from "../../../assets/images/icon_svg/track.svg";
import { ReactComponent as Cnicon } from "../../../assets/images/icon_svg/plane.svg";
import { ReactComponent as Mlicon } from "../../../assets/images/icon_svg/mail.svg";
import { ReactComponent as Amicon } from "../../../assets/images/icon_svg/clip.svg";
import { ReactComponent as Reset } from "../../../assets/images/icon_svg/reset_icon.svg";
import { ReactComponent as AIIcon } from "../../../assets/images/icon_svg/AI_icon.svg";
import { ReactComponent as Save_icon } from '../../../assets/images/save.svg';
import { ReactComponent as Piece } from '../../../assets/images/icon_svg/piece.svg';
import { ReactComponent as Search } from '../../../assets/images/icon_svg/search.svg';
import { ReactComponent as Error } from '../../../assets/images/icon_svg/error.svg';
import { ReactComponent as Forward } from '../../../assets/images/icon_svg/forward.svg';
import { ReactComponent as Map } from "../../../assets/images/icon_svg/map.svg";
import { ReactComponent as ReOpen } from "../../../assets/images/icon_svg/reopen.svg";
import { ReactComponent as BlackCheck } from "../../../assets/images/icon_svg/blckchck_circle.svg";
import { ReactComponent as Plus } from "../../../assets/images/icon_svg/plus.svg";
import { ReactComponent as User } from "../../../assets/images/icon_svg/user_history.svg";
import { ReactComponent as Calander } from "../../../assets/images/icon_svg/grayCalnder.svg";
import { ReactComponent as Close } from "../../../assets/images/icon_svg/red_cross.svg";
import { ReactComponent as History_icon } from "../../../assets/images/icon_svg/history_icon.svg";
import { ReactComponent as Stake_holder } from "../../../assets/images/icon_svg/stake_holder.svg";
import { ReactComponent as MoreOption } from "../../../assets/images/icon_svg/moreOption_icon.svg";
import { ReactComponent as Task } from "../../../assets/images/icon_svg/task.svg";
import { ReactComponent as Save } from "../../../assets/images/icon_svg/save.svg";
import add from "../../../assets/images/add.svg";

import Overview from './Components/Overview'
import StakeHolders from './Components/StakeHolders'
import Tracking from './Components/Tracking'
import Communication from './Components/Communication'
import Tasks from './Components/Tasks'
import Attachment from '../../../Components/common/Attachment';
import redCross from '../../../assets/images/red-cross.png'
import { drop } from 'lodash';
import AddStationHandler from '../../../Components/common/AddStationHandler';
import History from './Components/History';
import { useV2DropdownListMutation } from '../../../redux/services/SRC';

const OvDetails = ({ dropData, onRecEdit, onReload, stationList, stationReload, sendExtraHeader, onDetails }) => {

    const detID = JSON.parse(localStorage.getItem('OVDetails'));
    const isMounted = useRef(false);
    const [selectedTab, setSelectedTab] = useState('OV')
    const [disLoading, setDisLoading] = useState(false)
    const [details, setDetails] = useState({})
    const [otherStation, setOtherStation] = useState([])
    const [userList, setUserList] = useState([])
    const [resolveCode, setResolveCode] = useState([])
    const [updateModal, setUpdateModal] = useState(false)
    const [smallModal, setSmallModal] = useState(false)
    const [addressShow, setAddressShow] = useState(false)
    const [modalPos, setModalPos] = useState({})
    const [formData, setFormData] = useState({})

    const [getDestination, setGetDestination] = useState([]);
    const [extraStation, setExtraStation] = useState({})
    const [stationHandler, setStationHandler] = useState([]);
    const [selectedStationId, setSelectedStationId] = useState(null);
    const [selectedStationHandler, setSelectedStationHandler] = useState(null);
    const [sendHandler, setSendHandler] = useState({});

    const loadDetails = () => {
        setDisLoading(true);
        CallApi({
            endPoint: 'v2/service-recovery/details',
            payload: { service_recovery_id: detID.service_recovery_id },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    setDetails(innerData);
                    if (innerData?.recovery_cases?.length) {
                        // localStorage.setItem('extraHeader', JSON.stringify(innerData?.recovery_cases));
                        const filterParent = innerData?.recovery_cases.filter(i => i.service_recovery_id !== detID.service_recovery_id)
                        sendExtraHeader(filterParent)
                    }
                } else {
                    toast.error(res.data.response_msg)
                }
                setDisLoading(false);
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const fetchUser = () => {
        setDisLoading(true);
        CallApi({
            endPoint: 'v2/service-recovery/assign-user-list',
            payload: { service_recovery_id: detID.service_recovery_id },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    const assignUserOpt = [
                        { label: 'Unassign', value: '' },
                        ...(innerData || [])
                    ];
                    setUserList(assignUserOpt);
                } else {
                    toast.error(res.data.response_msg)
                }
                setDisLoading(false);
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const fetchDrop = (ids) => {
        CallApi({
            endPoint: 'v2/service-recovery/dropdown-list',
            payload: { irregularity_type: ids },
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                setResolveCode(innerData?.recovery_phase_to_close);
            },
            onError: (msg) => console.error(msg)
        });
    }

    useEffect(() => {
        if (isMounted.current) return;
        loadDetails();
        fetchUser();
        isMounted.current = true;
    }, []);

    useEffect(() => {
        if (onReload) loadDetails();
    }, [onReload])

    useEffect(() => {
        if (stationList) {
            const selectedDestination = stationList.find(stn => stn.station_id === extraStation.station_id);
            setStationHandler(selectedDestination ? selectedDestination.address : []);
            setGetDestination(stationList)


            const filterOtherStation = stationList?.filter(station => !details?.all_routing?.some(route => route.station_code === station.value));
            setOtherStation(filterOtherStation)
        }
    }, [stationList])

    const onChange = (val) => {
        setSelectedTab(val)
    }

    const handleEdit = () => {
        onRecEdit(details)
    }
    const openCase = (pos, stn, edt = false) => {
        setUpdateModal(true)
        let od = {}
        if (pos === 'URC') {
            od = { title: 'Update Recovery Case', subTitle: 'Select a station and record the latest recovery update.' }
            if (!edt) setFormData({})
        } else if (pos === 'CRC') {
            od = {
                title: `Close Recovery Case ${details?.master_airway_bill_prefix}-${details?.master_airway_bill_no}`,
                subTitle: 'Finalize the recovery process and record the case outcome.'
            }
            setFormData({
                service_recovery_id: [details?.service_recovery_id],
                irregularity_type: details.irregularity_type,
                resolving_code: details.resolving_code ?? '',
                custom_resolving_code: details.custom_resolving_code ?? '',
                error_station: details.error_station ?? '',
                error_station: details.error_station ?? '',
                other_station: details.other_station ?? '',
                closure_remarks: details.closure_remarks ?? '',
            })
            if (details?.irregularity_type.length) {
                fetchDrop(details.irregularity_type)
            }
        } else if (pos === 'UHS') {
            od = {
                title: `Update Handler Status - ${stn.station_code} (${stn.handler_name ?? '-'})`,
                subTitle: 'Set the current status and provide an update for this handler.',
                data: stn
            }
            setFormData({ shipment_routing_id: stn.shipment_routing_id, action_status_id: stn.action_status_id })
        } else if (pos === 'RC') {
            od = {
                title: 'Reopen Case',
                // subTitle: 'This will reopen the case and remove all closure details.',
            }
            setFormData({ shipment_routing_id: stn?.shipment_routing_id, action_status_id: stn?.action_status_id })
        }
        setModalPos({
            pos: pos,
            ...od
        })
    }
    const updateModalClose = () => {
        setUpdateModal(false)
    }
    const Status = [
        { name: 'Pending', value: 1 },
        { name: 'Awaiting Response', value: 2 },
        { name: 'Investigating', value: 3 },
        { name: 'Response Received', value: 4 },
        { name: 'No Response', value: 5 },
    ]
    const statusChange = (data) => {
        setFormData(prev => ({ ...prev, action_status_id: data.value }))
    }
    const closeRecovery = (pos) => {
        CallApi({
            endPoint: 'v2/service-recovery/close-recovery',
            payload: {...formData, confirm_closure: pos === 'S' ? null : 1},
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg);
                    loadDetails()
                    updateModalClose()
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => console.error(msg)
        });
    }
    const reOpenRecovery = () => {
        CallApi({
            endPoint: 'v2/service-recovery/open-recovery',
            payload: { service_recovery_id: details.service_recovery_id },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg);
                    loadDetails()
                    updateModalClose()
                } else {
                    toast.success(res.data.response_msg)
                }

            },
            onError: (msg) => console.error(msg)
        });
    }
    const addExtraStn = () => {
        const transformedData = {
            ...details,
            all_routing: [
                ...details.all_routing,
                {
                    station_code: extraStation.station_code,
                    handler_type: 'Wrong Station',
                    handler_id: extraStation.station_handler_id ?? '',
                }
            ]
        }

        handleFinish(transformedData, 'extra')
    }
    const validateFormData = () => {
        let isValid = true;
        // if (!formData.booking_type) {
        //     console.log('Text input is required');
        //     toast.error('Please set Booking Type');
        //     isValid = false;
        // } 
        if (formData?.recovery_action == 'pieces_found') {
            if (!formData?.pieces_found) {
                console.log('Text input is required');
                toast.error('Insert Pieces Found');
                isValid = false;
            } else if (!formData?.condition) {
                console.log('Text input is required');
                toast.error('Select Condition');
                isValid = false;
            } else if (!formData?.location_found) {
                console.log('Text input is required');
                toast.error('Enter location');
                isValid = false;
            } else if (!formData?.found_date_time) {
                console.log('Text input is required');
                toast.error('Enter Found Date');
                isValid = false;
            }
            else {
                return isValid;
            }
        } else if (formData?.recovery_action == 'forwarded') {
            if (!formData?.transport_method) {
                console.log('Text input is required');
                toast.error('Please Select Transport Moethod');
                isValid = false;
            } else if (!formData?.departure_date_time) {
                console.log('Text input is required');
                toast.error('Enter Departure Date');
                isValid = false;
            }
            else {
                return isValid;
            }
        }
        else {
            return isValid;
        }
    };
    const updateRecovery = () => {
        if (modalPos.pos === 'URC') {
            if (!validateFormData()) return;
        }
        CallApi({
            endPoint: 'handler-shipment-routing/update',
            payload: formData,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg);
                    loadDetails()
                    updateModalClose()
                } else {
                    toast.error(res.data.response_msg)
                }

            },
            onError: (msg) => console.error(msg)
        });
    }

    const stnClick = (data) => {
        // console.log('stn', data);
        setFormData(prev => ({ ...prev, shipment_routing_id: data.shipment_routing_id, action_status_id: data.action_status_id, recovery_action: '' }))
    }

    const actionClick = (actn) => {
        const { action_status_id, shipment_routing_id, ...rest } = formData;
        setFormData(prev => ({ recovery_action: actn, action_status_id, shipment_routing_id }))
    }

    const detailsChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }))
        // if (modalPos?.pos === 'URC') {
        //     setFormData(prev => ({ ...prev, recovery_action: { ...prev.recovery_action, [name]: value } }))
        // } else if (modalPos?.pos === 'CRC') {
        //     setFormData(prev => ({ ...prev, [name]: value }))
        // }
    }


    const dropdownChange = (name, value) => {
        // console.log('0', name);
        const sendData = { ...details, [name]: value.value }
        handleFinish(sendData)
        // if (name == 'assign_to') {
        //     const sendData = { ...details, [name]: value.value }
        //     // console.log('sendData 1', sendData);
        //     handleFinish(sendData)
        // } else {
        //     const sendData = { ...details, [name]: value.value }
        //     handleFinish(sendData)
        // }
    }
    const handleFinish = async (sendData, et) => {

        CallApi({
            endPoint: 'v2/service-recovery/save',
            // payload: formData.service_recovery_id ? formData : transformedData,
            payload: sendData,
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg);
                    loadDetails()
                    if (et === 'extra') {
                        closeSmallModal()
                    }
                } else {
                    toast.success(res.data.response_msg)
                }

            },
            onError: (msg) => console.error(msg)
        });
    }
    const sendData = { id: detID.service_recovery_id, service_recovery_id: detID.service_recovery_id, attType: 'airline_service_recovery' }

    const addStation = () => setSmallModal(true)
    const closeSmallModal = () => {
        setSmallModal(false)
        setExtraStation({})
        setSelectedStationHandler(null)
    }
    const addressModalOpen = () => {
        setSendHandler({
            // frmData: initInput,
            station_code: extraStation.station_code,
            handler_type: 'Station',
            station_id: extraStation?.station_id,
            title: 'Add Address - ' + extraStation?.station_code,
            subTitle: 'Create a new address for this station'
        });
        setAddressShow(true);
    };

    const handleModalSubmit = () => stationReload()

    const editUrc = (id, srId) => {
        console.log('srid', srId);

        CallApi({
            endPoint: 'handler-shipment-routing/update-details',
            payload: { routing_update_id: id },
            onSuccess: (res) => {
                if (res.data.response_code === 200) {
                    setFormData({ ...res.data.response_data, action_status_id: srId });
                    openCase('URC', '', true)
                } else {
                    // toast.success(res.data.response_msg)
                }

            },
            onError: (msg) => console.error(msg)
        });
    }
    const detailsTitle = {
        pieces_found: 'Pieces Found',
        checks_performed: 'Check Performed',
        unable_to_locate: 'Unable to Locate',
        forwarded: 'Forwarded'
    }

    // const errorStation = [{label: 'Unknown', value: 'unknown'}, ...stationList]
    const filterErrorStation = stationList?.filter(station => details?.all_routing?.some(route => route.station_code === station.value))
    const errorStation = [{ label: 'Unknown', value: 'unknown' }, ...filterErrorStation, { label: 'Other', value: 'other' }]

    const changeDetails = (id) => {
        const dTitle = localStorage.getItem('DetailsTitle');
        onDetails({ service_recovery_id: id, master_airway_bill: dTitle })
    }

    return (
        <>
            {disLoading &&
                <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
            }
            <div className='d-flex justify-content-between '>
                <div className="main-content tw-74">
                    <div className='d-flex justify-content-between align-items-center' style={{ marginBottom: '10px' }}>
                        <div className='topNav'>
                            <button onClick={() => onChange('OV')} className={selectedTab === 'OV' ? 'nav_active' : ''}><Ovicon />Overview</button>
                            <button onClick={() => onChange('SH')} className={selectedTab === 'SH' ? 'nav_active' : ''}><Stake_holder />Stakeholders</button>
                            <button onClick={() => onChange('TR')} className={selectedTab === 'TR' ? 'nav_active' : ''}><Tkicon />Tracking</button>
                            {/* <button onClick={() => onChange('CM')} className={selectedTab === 'CM' ? 'nav_active' : ''}><Mlicon />Communication</button> */}
                            {/* <button onClick={() => onChange('TK')} className={selectedTab === 'TK' ? 'nav_active' : ''}><Task />Task</button> */}
                            <button onClick={() => onChange('ATT')} className={selectedTab === 'ATT' ? 'nav_active' : ''}><Amicon />Attachments</button>
                            <button onClick={() => onChange('HI')} className={selectedTab === 'HI' ? 'nav_active' : ''}><History_icon />History</button>
                        </div>
                        {/* <div><button className='summry_btn'><AIIcon />Summary</button></div> */}
                        <div>
                            <Col xs="auto">
              <Dropdown align="end">
                <Dropdown.Toggle
                  variant="light"
                  className="border-0 shadow-none"
                  id="dropdown-menu"
                >
                 <MoreOption />
 
                </Dropdown.Toggle>
 
                <Dropdown.Menu>
                  <Dropdown.Item>View</Dropdown.Item>
                  <Dropdown.Item>Edit</Dropdown.Item>
                  <Dropdown.Item>Delete</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
                        </div>
                    </div>
                    {selectedTab === 'OV' && <Overview propData={details} drpData={dropData} onReload={loadDetails} onEdit={handleEdit} onChangeDetails={changeDetails} />}
                    {selectedTab === 'SH' &&
                        <>
                            <div className='d-flex justify-content-between align-items-center summary_card' style={{ padding: '7px 10px' }}>
                                <div className='d-flex align-items-center gap-2'>
                                    <h6 className='mb-0'>Stations Involved</h6>
                                    <span><span className='gray_badge me-1'>{details?.all_routing?.length}</span>Stations</span>
                                </div>
                                <div className='d-flex align-items-center'>
                                    <button className='add_btn external_station' onClick={addStation}>
                                        + Add External Station
                                    </button>
                                    {/* <Button variant='none' className='outline_btn_blue'>Manage Stations</Button> */}
                                </div>
                            </div>
                            <StakeHolders propData={details} onReload={loadDetails} editStatus={editUrc} />
                        </>
                    }
                    {selectedTab === 'TR' && <Tracking propData={details} dropData={dropData} />}
                    {selectedTab === 'CM' && <Communication propData={details} onReload={loadDetails} />}
                    {selectedTab === 'TK' && <Tasks />}
                    {selectedTab === 'ATT' && <div className='attachments_cmn'><Attachment propData={details} submitData={sendData} onReload={loadDetails} /></div>}
                    {selectedTab === 'HI' && <History propData={details} recordId={details?.service_recovery_id} />}
                </div>
                <div className='tw-26 case_action_card ex_height'>
                    <div className='info_card_title d-flex justify-content-between align-items-center'>
                        <div className='info_title_wrap'>
                            <h6>Case Actions</h6>
                        </div>
                        <Button variant='contained' className={details?.is_recovery_closed ? 'blue_btn' : 'danger_btn'} onClick={() => openCase(details?.is_recovery_closed ? 'RC' : 'CRC')}>
                            {details?.is_recovery_closed ?
                                <> <ReOpen /> Reopen Case</>
                                :
                                <> <Close width={16} height={16} /> Close Case </>
                            }
                        </Button>
                    </div>
                    {/* {console.log('errorStation', otherStation)} */}
                    {/* {console.log('stationList', stationList)} */}
                    {details?.is_recovery_closed ?
                        <div className='summary_card reopnCase mt-3'>
                            <div className='info_card_title d-flex justify-content-between align-items-center p-0 pb-2'>
                                <h6 className='d-flex align-items-center'><BlackCheck className='me-2' />Closed</h6>
                                <span>{details?.closed_at.slice(0, 16)}</span>
                            </div>
                            <div className="resolving-wrapper pt-1">
                                <div className="mb-1 label">Resolving Code</div>
                                <div className="main-title mb-2">
                                    {details?.resolving_code_name === "Other" ? details?.custom_resolving_code : details?.resolving_code_name}
                                </div>
                                <Row className="mb-2">
                                    <Col xs={6}>
                                        <div className="label mb-1">Error Station</div>
                                        <div className="main-title">{details?.error_station}</div>
                                    </Col>

                                    <Col xs={6}>
                                        <div className="label mb-1">Closed By</div>
                                        <div className="main-title">{details?.closed_by}</div>
                                    </Col>
                                </Row>
                                <div className='mb-2'>
                                    <div className="label mb-1">Remarks</div>
                                    <div className="main-title">
                                        {details?.closure_remarks}
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='mt-2'>
                            <Form.Group controlId="assignedRegion" className='mb-2'>
                                <Form.Label>Action Status</Form.Label>
                                <Select
                                    options={dropData?.action_status}
                                    onChange={(selected) => dropdownChange('action_status_id', selected)}
                                    placeholder="Action Required"
                                    className="region_selct"
                                    name="tmplt"
                                    value={dropData?.action_status?.find(option => option.value === details?.action_status_id) || null}
                                />
                                {/* <Form.Select defaultValue="West-Europe">
                                <option>West-Europe</option>
                                <option>East-Europe</option>
                                <option>North America</option>
                            </Form.Select> */}
                            </Form.Group>
                            <div className='d-flex gap-3 mb-2'>

                                <Form.Group controlId="priorityLevel" className='tw-40'>
                                    <Form.Label>Priority Level</Form.Label>
                                    <Select
                                        options={dropData?.priority_type}
                                        onChange={(selected) => dropdownChange('priority_id', selected)}
                                        placeholder="Select Priority"
                                        className="region_selct"
                                        name="tmplt"
                                        value={dropData?.priority_type?.find(option => option.value === details?.priority_id) || null}
                                    />
                                    {/* <Form.Select defaultValue="Low">
                                    <option>Low</option>
                                    <option>Medium</option>
                                    <option>High</option>
                                </Form.Select> */}
                                </Form.Group>

                                <Form.Group controlId="recoveryPhase" className='tw-60'>
                                    <Form.Label>Recovery Phase</Form.Label>
                                    <Select
                                        options={dropData?.recovery_phase}
                                        onChange={(selected) => dropdownChange('recovery_phase', selected)}
                                        placeholder="Recovery Phase"
                                        className="region_selct"
                                        name="tmplt"
                                        value={dropData?.recovery_phase?.find(option => option.value === details?.recovery_phase) || null}
                                    />
                                    {/* <Form.Select defaultValue="Customs Declared">
                                    <option>Customs Declared</option>
                                    <option>In Transit</option>
                                    <option>Delivered</option>
                                </Form.Select> */}
                                </Form.Group>

                            </div>

                            <Form.Group controlId="assignedRegion" className='mb-2'>
                                <Form.Label>Assigned Region</Form.Label>
                                <Select
                                    options={dropData?.region_list}
                                    onChange={(selected) => dropdownChange('region_id', selected)}
                                    placeholder="Assigned Region"
                                    className="region_selct"
                                    name="tmplt"
                                    value={dropData?.region_list?.find(option => option.value === details?.region_id) || null}
                                />
                                {/* <Form.Select defaultValue="West-Europe">
                                <option>West-Europe</option>
                                <option>East-Europe</option>
                                <option>North America</option>
                            </Form.Select> */}
                            </Form.Group>

                            <Form.Group controlId="assignedUser" className='mb-2'>
                                <Form.Label>Case Owner</Form.Label>
                                <Select
                                    options={userList}
                                    onChange={selected => dropdownChange('assign_to', selected)}
                                    placeholder="Case Owner"
                                    className="region_selct"
                                    name="tmplt"
                                    value={userList?.find(opt => opt.value === details?.assign_to) || null}
                                />
                                {/* <Form.Select defaultValue="User 1">
                                <option>User 1</option>
                                <option>User 2</option>
                                <option>User 3</option>
                            </Form.Select> */}
                            </Form.Group>


                        </div>
                    }
                    <div className='primary_bg_card mb-2'>
                        <h6>Stakeholder Status</h6>
                        {details?.all_routing?.map((stn, index) => {
                            const clss = {
                                267: 'gray_btn',
                                268: 'orng_btn',
                                269: 'blue_btn',
                                270: 'orng_btn',
                                281: 'red_bg_btn',
                                283: 'gray_btn',
                            }
                            return (
                                <div className="d-flex justify-content-between align-items-center over_bg" key={stn.handler_id + '_' + index}>
                                    <div className='stake_text'>
                                        <div>
                                            <h3 className="">{stn.station_code} - {stn.handler_type}</h3>
                                            <p className="">{stn.handler_name || '-'}</p>
                                        </div>

                                        <div>
                                            {stn.is_reported ? <Map width={30} height={30} /> : <></>}
                                        </div>
                                    </div>

                                    <div>
                                        <span className={clss[stn.action_status_id]} onClick={() => openCase('UHS', stn)}>
                                            {stn?.action_status}
                                        </span>
                                        {/* <span className='orng_btn'>
                                    Response Received
                                </span> */}
                                    </div>

                                </div>
                            )
                        })}

                        {/* <div className="align-items-center summary_card d-flex justify-content-between">
                        <div>
                            <div className="fw-semibold">BRE - Station</div>
                            <div className="text-muted small">World Flight Services</div>
                        </div>
                        <div xs="auto">
                            <span className='orng_btn'>
                                Response Received
                            </span>
                        </div>
                    </div>
                    <div className="align-items-center summary_card d-flex justify-content-between">
                        <Col>
                            <div className="fw-semibold">HKG - Destination</div>
                            <div className="text-muted small">Swissport</div>
                        </Col>
                        <Col xs="auto">
                            <span className='gray_btn'>
                                Pending
                            </span>
                        </Col>
                    </div> */}
                        {!details?.is_recovery_closed &&
                            <Button variant="contained" className="w-100 d-flex align-items-center justify-content-center gap-2 create_btn" onClick={() => openCase('URC')}>
                                <Reset />Update Recovery Case
                            </Button>
                        }
                    </div>
                    {/* ++++++++++ task managment Start +++++++++ */}
                    {/* <div className='s_rcvryOpnTask'>
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header><span className='opntask_txt'>Open Tasks </span><span className='gray_badge ms-2'>3</span><span className='ms-auto blue_btn me-2'><Plus className='me-1' />Task</span></Accordion.Header>
                                <Accordion.Body>
                                    <div className='summary_card'>
                                        <div className='d-flex gap-3 justify-content-between align-items-center'>
                                            <div>
                                                <h6>Request missing documentation</h6>
                                                <p className='mb-0'><span><User className='me-1' />User 1</span><span><Calander className='me-1 ms-3 calender_icon' />Due 24-01-2026</span></p>
                                            </div>
                                            <div>
                                                <span className='blue_btn'>Open</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='summary_card'>
                                        <div className='d-flex gap-3 justify-content-between align-items-center'>
                                            <div>
                                                <h6>Request missing documentation</h6>
                                                <p className='mb-0'><span><User className='me-1' />User 1</span><span><Calander className='me-1 ms-3 calender_icon' />Due 24-01-2026</span></p>
                                            </div>
                                            <div>
                                                <span className='orng_btn'>In Progress</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='summary_card'>
                                        <div className='d-flex gap-3 justify-content-between align-items-center'>
                                            <div>
                                                <h6>Request missing documentation</h6>
                                                <p className='mb-0'><span><User className='me-1' />User 1</span><span><Calander className='me-1 ms-3 calender_icon' />Due 24-01-2026</span></p>
                                            </div>
                                            <div>
                                                <span className='red_bg_btn'>Overdue</span>
                                            </div>
                                        </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div> */}

                    {/* ++++++++++ task managment End +++++++++ */}


                </div>
            </div>
            {/* {console.log('fd', formData)} */}
            <CommonModal
                show={updateModal}
                // onHide={handleModalClose}
                onHide={updateModalClose}
                title={modalPos?.title}
                subTitle={modalPos?.subTitle}
                className={`modal_bgw primary_modal modal_width_551 ${modalPos?.pos === 'URC' ? 'update_recovery_modal' : ''}`}
                footer={
                    <div className='d-flex w-100 justify-content-between '> {/* w-50 mx-auto are_bottom */}
                        {modalPos?.pos === 'UHS' ?
                            <>
                                <Button variant="secondary" onClick={updateModalClose}> Cancel </Button>
                                <Button variant="primary" onClick={updateRecovery} className="ms-auto"> Update </Button>
                            </>
                            : modalPos?.pos === 'URC' ?
                                <>
                                    <div></div>
                                    <Button variant="primary" onClick={updateRecovery}>
                                        <Save_icon /> Update Recovery
                                    </Button>
                                </>
                                : modalPos?.pos === 'CRC' ?
                                    <>
                                        <Button variant="secondary" onClick={updateModalClose}> Cancel </Button>
                                        <Button variant="contained" className='btn-normal push-right' onClick={() => closeRecovery('S')}> <Save width={16} height={16} /> Save Changes </Button>
                                        <Button variant="primary" onClick={closeRecovery} className="ms-auto"> Confirm Closure </Button>
                                    </>
                                    : modalPos?.pos === 'RC' ?
                                        <>
                                            <Button variant="secondary" onClick={updateModalClose}> Cancel </Button>
                                            <Button variant="primary" onClick={reOpenRecovery} className="ms-auto"> Reopen Case </Button>
                                        </>
                                        : ''
                        }

                    </div>
                }
            >
                {modalPos?.pos === 'RC' &&
                    <div>
                        This will reopen the case and remove all closure details.
                    </div>
                }
                {modalPos?.pos === 'UHS' &&
                    <div>
                        {dropData?.handler_action_status?.map((st, index) => (
                            <button
                                className={`handleStsBtn w-100 ${formData?.action_status_id === st.value ? 'active' : ''}`}
                                key={st.value + '_' + index}
                                onClick={() => statusChange(st)}
                            >
                                {st.label}
                            </button>
                        ))}
                    </div>
                }
                {modalPos?.pos === 'CRC' &&
                    <div>
                        <Form.Group className='mb-2'>
                            <Form.Label>Irregularity Type <span className='red'>*</span></Form.Label>
                            <Select
                                options={dropData?.irregularity_type}
                                // value={multiDropDown?.irregularity_type.find(option => option.value === formData.irregularity_type) || ''}
                                value={dropData?.irregularity_type?.filter(item => formData?.irregularity_type?.includes(item.value))}
                                onChange={(selected) => {
                                    const selectedIds = selected.map(item => item.value);
                                    fetchDrop(selectedIds)
                                    setFormData((prevFormData) => ({
                                        ...prevFormData,
                                        irregularity_type: selectedIds
                                    }));
                                    if (formData?.irregularity_type?.length === 0) {
                                        setResolveCode([])
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            resolving_code: ''
                                        }));
                                    }
                                    // setFormData(prevFormData => {
                                    //     const newFormData = { ...prevFormData, irregularity_type: selected.value };
                                    //     return newFormData;
                                    // });
                                }}
                                labelledBy="Select "
                                placeholder="Irregularity Type"
                                isMulti
                            // className='multiselect_brd add_shc'
                            />
                        </Form.Group>
                        {/* {console.log('resolveCode', resolveCode)} */}
                        <Form.Group className='mb-2'>
                            <Form.Label>Resolving Code (Options based on Irregularity Type) <span className='red'>*</span></Form.Label>
                            <Select
                                options={resolveCode}
                                value={resolveCode?.find(option => option.value === formData.resolving_code) || ''}
                                // value={resolveCode?.filter(item => formData?.resolving_code?.includes(item.value))}
                                onChange={(selected) => {
                                    // const selectedIds = selected.map(item => item.value);
                                    // setFormData((prevFormData) => ({
                                    //     ...prevFormData,
                                    //     resolving_code: selectedIds
                                    // }));
                                    setFormData(prevFormData => {
                                        const newFormData = { ...prevFormData, resolving_code: selected.value };
                                        return newFormData;
                                    });
                                }}
                                labelledBy="Select "
                                placeholder="Resolving Code"
                            // isMulti
                            // className='multiselect_brd add_shc'
                            />
                        </Form.Group>
                        {formData?.resolving_code === 263 &&
                            <Form.Group className='mb-2'>
                                <Form.Label>Custom Resolving Code <span className='red'>*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={detailsChange}
                                    name='custom_resolving_code'
                                    value={formData?.custom_resolving_code || ''}
                                    placeholder="Custom Resolving Code"
                                />
                            </Form.Group>
                        }
                        <Form.Group className='mb-2'>
                            <Form.Label>Error Station <span className='red'>*</span></Form.Label>
                            <Select
                                options={errorStation}
                                value={errorStation.find(option => option.value === formData.error_station) || ''}
                                // value={stationList?.filter(item => formData?.error_station?.includes(item.value))}
                                onChange={(selected) => {
                                    // const selectedIds = selected.map(item => item.value);
                                    // setFormData((prevFormData) => ({
                                    //     ...prevFormData,
                                    //     error_station: selectedIds
                                    // }));
                                    setFormData(prevFormData => {
                                        const newFormData = { ...prevFormData, error_station: selected.value };
                                        return newFormData;
                                    });
                                }}
                                labelledBy="Select "
                                placeholder="Error Station"
                            // isMulti
                            // className='multiselect_brd add_shc'
                            />
                            {formData?.error_station === 'other' &&
                                <>
                                    <Form.Label>Other Station <span className='red'>*</span></Form.Label>
                                    <Select
                                        options={otherStation}
                                        value={otherStation.find(option => option.value === formData.other_station) || ''}
                                        // value={stationList?.filter(item => formData?.error_station?.includes(item.value))}
                                        onChange={(selected) => {
                                            // const selectedIds = selected.map(item => item.value);
                                            // setFormData((prevFormData) => ({
                                            //     ...prevFormData,
                                            //     error_station: selectedIds
                                            // }));
                                            setFormData(prevFormData => {
                                                const newFormData = { ...prevFormData, other_station: selected.value };
                                                return newFormData;
                                            });
                                        }}
                                        labelledBy="Select "
                                        placeholder="Error Station"
                                    // isMulti
                                    // className='multiselect_brd add_shc'
                                    />
                                </>
                            }
                        </Form.Group>
                        <Form.Group className='mb-2'>
                            <Form.Label>Closure Remark {formData?.error_station === 'unknown' && <span className='red'>*</span>}</Form.Label>
                            <Form.Control
                                as="textarea"
                                name='closure_remarks'
                                aria-label="With textarea"
                                type="text"
                                style={{ resize: 'none',height: '142px' }}
                                value={formData?.closure_remarks || ''}
                                onChange={detailsChange}
                                placeholder="Write a remark"
                            />
                        </Form.Group>
                    </div>
                }
                {modalPos?.pos === 'URC' &&
                    <div>

                        <div className='d-flex align-items-center'>
                            <h6 className='m-0'>Select Station</h6>
                            {!formData?.routing_update_id && <Button variant="link" className='link_btn' onClick={addStation}>+ Add External Station</Button>}

                        </div>
                        {details?.all_routing?.map((stn, index) => {
                            const clss = {
                                267: 'gray_btn',
                                268: 'orng_btn',
                                269: 'blue_btn',
                                270: 'orng_btn',
                                281: 'red_bg_btn',
                                283: 'gray_btn',
                            }
                            return (
                                <div
                                    className={`d-flex justify-content-between align-items-center over_bg ${stn.shipment_routing_id === formData?.shipment_routing_id ? 'active' : ''}`}
                                    key={stn.handler_id + '__' + index}
                                    onClick={() => {
                                        if (!formData?.routing_update_id) stnClick(stn)
                                    }
                                    }
                                >
                                    <div className='stake_text'>
                                        <h3 className="">{stn.station_code} - {stn.handler_type} <span className="divd"> </span> <span className="handler">{stn.handler_name || '-'}</span> <span className='px-2'>{stn.is_reported ? <Map width={20} height={20} /> : <></>}</span></h3>
                                    </div>
                                    <div>
                                        <span className={clss[stn.action_status_id]}>
                                            {stn?.action_status}
                                        </span>
                                        {/* <span className='orng_btn'>
                                    Response Received
                                </span> */}
                                    </div>
                                </div>
                            )
                        })}

                        {formData?.shipment_routing_id &&
                            <>
                                <h6>Recovery Action</h6>
                                <div className='d-flex flex-wrap gap-2 mb-3'>
                                    <Button
                                        variant="none"
                                        className={`rcvryActnBtn ${formData?.recovery_action === 'pieces_found' ? 'active' : ''}`}
                                        onClick={() => actionClick('pieces_found')}
                                        disabled={formData?.routing_update_id}
                                    >
                                        <Piece />Pieces Found
                                    </Button>
                                    <Button
                                        variant="none"
                                        className={`rcvryActnBtn ${formData?.recovery_action === 'checks_performed' ? 'active' : ''}`}
                                        onClick={() => actionClick('checks_performed')}
                                        disabled={formData?.routing_update_id}
                                    >
                                        <Search />Check Performed
                                    </Button>
                                    <Button
                                        variant="none"
                                        className={`rcvryActnBtn ${formData?.recovery_action === 'unable_to_locate' ? 'active' : ''}`}
                                        onClick={() => actionClick('unable_to_locate')}
                                        disabled={formData?.routing_update_id}
                                    >
                                        <Error />Unable to Locate
                                    </Button>
                                    <Button
                                        variant="none"
                                        className={`rcvryActnBtn ${formData?.recovery_action === 'forwarded' ? 'active' : ''}`}
                                        onClick={() => actionClick('forwarded')}
                                        disabled={formData?.routing_update_id}
                                    >
                                        <Forward />Forwarded
                                    </Button>
                                </div>
                            </>
                        }

                        {formData?.recovery_action &&
                            <>
                                <h6>{detailsTitle[formData?.recovery_action]} - Details</h6>

                                {formData?.recovery_action === 'pieces_found' &&
                                    <>
                                        <div className='d-flex w-100 gap-3'>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Pieces Found <span className='red'>*</span></Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    onChange={detailsChange}
                                                    name='pieces_found'
                                                    value={formData?.pieces_found || ''}
                                                    placeholder="Total Pieces Found"
                                                />
                                            </Form.Group>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Condition <span className='red'>*</span></Form.Label>
                                                <Select
                                                    options={dropData?.condition}
                                                    value={dropData?.condition.find(option => option.value === formData?.condition) || ''}
                                                    // value={dropData?.condition?.filter(item => formData?.condition?.includes(item.value))}
                                                    onChange={(selected) => {
                                                        // const selectedIds = selected.map(item => item.value);
                                                        // setFormData((prevFormData) => ({
                                                        //     ...prevFormData,
                                                        //     recovery_action: { ...prevFormData.recovery_action, condition: selectedIds }
                                                        // }));
                                                        setFormData(prevFormData => {
                                                            const newFormData = {
                                                                ...prevFormData,
                                                                condition: selected.value
                                                            };
                                                            return newFormData;
                                                        });
                                                    }}
                                                    labelledBy="Select "
                                                    placeholder="Condition Shipment"
                                                // isMulti
                                                // className='multiselect_brd add_shc'
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className='d-flex w-100 gap-3'>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Location Found <span className='red'>*</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    onChange={detailsChange}
                                                    name='location_found'
                                                    value={formData?.location_found || ''}
                                                    placeholder="Location Found"
                                                />
                                            </Form.Group>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Date/Time Found <span className='red'>*</span></Form.Label>
                                                <Form.Control
                                                    type='datetime-local'
                                                    placeholder=""
                                                    name="found_date_time"
                                                    value={formData?.found_date_time || ''}
                                                    onChange={detailsChange}
                                                />
                                            </Form.Group>

                                        </div>
                                    </>
                                }
                                {formData?.recovery_action === 'checks_performed' &&
                                    <>
                                        <div className='d-flex w-100 gap-3'>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Warehouse Check </Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    onChange={detailsChange}
                                                    name='warehouse_check'
                                                    value={formData?.warehouse_check || ''}
                                                    placeholder="Date Warehouse Check"
                                                />
                                            </Form.Group>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Spot Check </Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    onChange={detailsChange}
                                                    name='spot_check'
                                                    value={formData?.spot_check || ''}
                                                    placeholder="Date Spot Check"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className='d-flex w-100 gap-3'>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Agent Check </Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    onChange={detailsChange}
                                                    name='agent_check'
                                                    value={formData?.agent_check || ''}
                                                    placeholder="Date Agent Check"
                                                />
                                            </Form.Group>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>CCTV Check </Form.Label>
                                                <Form.Control
                                                    type='datetime-local'
                                                    placeholder="Date CCTV Check"
                                                    name="cctv_check"
                                                    value={formData?.cctv_check || ''}
                                                    onChange={detailsChange}

                                                />
                                            </Form.Group>

                                        </div>
                                    </>
                                }
                                {formData?.recovery_action === 'unable_to_locate' &&
                                    <>
                                        <div className='d-flex w-100 gap-3'>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Checks Performed </Form.Label>
                                                <Select
                                                    options={dropData?.checks_performed}
                                                    // value={dropData?.checks_performed.find(option => option.value === formData?.recovery_action?.checks_performed) || ''}
                                                    value={dropData?.checks_performed?.filter(item => formData?.checks_performed?.includes(item.value))}
                                                    onChange={(selected) => {
                                                        const selectedIds = selected.map(item => item.value);
                                                        setFormData((prevFormData) => ({
                                                            ...prevFormData,
                                                            checks_performed: selectedIds
                                                        }));
                                                        // setFormData(prevFormData => {
                                                        //     const newFormData = {
                                                        //         ...prevFormData,
                                                        //         recovery_action: { ...prevFormData.recovery_action, checks_performed: selected.value }
                                                        //     };
                                                        //     return newFormData;
                                                        // });
                                                    }}
                                                    labelledBy="Select "
                                                    placeholder="Checks Performed"
                                                    isMulti
                                                // className='multiselect_brd add_shc'
                                                />
                                            </Form.Group>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Reported On <span className='red'>*</span></Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    onChange={detailsChange}
                                                    name='reported_on'
                                                    value={formData?.reported_on || ''}
                                                    placeholder="Date Spot Check"
                                                />
                                            </Form.Group>
                                        </div>
                                    </>
                                }
                                {formData?.recovery_action === 'forwarded' &&
                                    <>
                                        <div className='d-flex w-100 gap-3'>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Transport Method <span className='red'>*</span></Form.Label>
                                                <Select
                                                    options={dropData?.transport_method}
                                                    value={dropData?.transport_method.find(option => option.value === formData?.transport_method) || ''}
                                                    // value={dropData?.transport_method?.filter(item => formData?.transport_method?.includes(item.value))}
                                                    onChange={(selected) => {
                                                        // const selectedIds = selected.map(item => item.value);
                                                        // setFormData((prevFormData) => ({
                                                        //     ...prevFormData,
                                                        //     irregularity_type: selectedIds
                                                        // }));
                                                        setFormData(prevFormData => {
                                                            const newFormData = {
                                                                ...prevFormData,
                                                                transport_method: selected.value
                                                            };
                                                            return newFormData;
                                                        });
                                                    }}
                                                    labelledBy="Select "
                                                    placeholder="Forwarded On"
                                                // isMulti
                                                // className='multiselect_brd add_shc'
                                                />
                                            </Form.Group>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Destination </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    onChange={detailsChange}
                                                    name='destination'
                                                    value={formData?.destination || ''}
                                                    placeholder="Destination"
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className='d-flex w-100 gap-3'>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Transport Reference </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    onChange={detailsChange}
                                                    name='transport_reference'
                                                    value={formData?.transport_reference || ''}
                                                    placeholder="Reference No."
                                                />
                                            </Form.Group>
                                            <Form.Group className='w-50 mb-2'>
                                                <Form.Label>Departure Date/Time <span className='red'>*</span></Form.Label>
                                                <Form.Control
                                                    type="datetime-local"
                                                    onChange={detailsChange}
                                                    name='departure_date_time'
                                                    value={formData?.departure_date_time || ''}
                                                    placeholder="Departure Date/Time"
                                                />
                                            </Form.Group>
                                        </div>
                                    </>
                                }

                                <Form.Group>
                                    <Form.Label>Remark</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        name='remark'
                                        aria-label="With textarea"
                                        type="text"
                                        style={{ resize: 'none', height: '85px' }}
                                        value={formData?.remark || ''}
                                        onChange={(e) => setFormData(prev => ({ ...prev, remark: e.target.value }))}
                                    />
                                </Form.Group>
                            </>
                        }
                    </div>
                }
            </CommonModal>
            {console.log('sendData', extraStation)}
            <CommonModal
                show={smallModal}
                onHide={closeSmallModal}
                title='Add External Station'
                subTitle='Add a station not part of the planned route'
                className='modal_bgw primary_modal'
                footer={
                    <div className='d-flex w-100 justify-content-between'>
                        <Button variant="secondary" onClick={closeSmallModal}> Cancel </Button>
                        <Button variant="primary" onClick={addExtraStn} className="ms-auto"> Add Station </Button>
                    </div>
                }
            >
                <Form.Group>
                    <Form.Label>Station <span className='red'>*</span></Form.Label>
                    <Select
                        options={getDestination}
                        onChange={(selected) => {
                            const selectedDestination = getDestination.find(option => option.value === selected.value);
                            const transHandler = [{ company_name: 'Select Handler', id: null }, ...selectedDestination.address]
                            setStationHandler(selectedDestination ? selectedDestination.address : []);
                            setSelectedStationId(selectedDestination.station_id);

                            // if (selectedDestination && selectedDestination.address.length === 1) {
                            const chkDefault = selectedDestination && selectedDestination.address.find(a => a.is_default_handler === 1)
                            if (chkDefault) {
                                const autoSelectedHandler = {
                                    value: chkDefault.id,
                                    label: chkDefault.company_name,
                                    email: chkDefault.handler_email_id,
                                    address: chkDefault.address,
                                    number: chkDefault.handler_phone_no,
                                    id: chkDefault.id,
                                    hoid: chkDefault.handler_org_id,
                                };
                                setSelectedStationHandler(autoSelectedHandler);

                                setExtraStation(prevFormData => ({
                                    ...prevFormData,
                                    station_code: selected.value,
                                    station_id: selected.station_id,
                                    station_handler_id: chkDefault.id
                                }));
                            } else {
                                // Clear handler selection if multiple or no handlers
                                setSelectedStationHandler(null);
                                setExtraStation(prevFormData => ({
                                    ...prevFormData,
                                    station_code: selected.value,
                                    station_id: selected.station_id,
                                    station_handler_id: ''
                                }));
                            }
                        }}
                        placeholder="Station"
                        className='autoslct w-100 p-0 mb-2'
                        name="station_code"
                        value={getDestination.find(option => option.value === extraStation.station_code) || ''}
                    />
                </Form.Group>
                <Form.Group className='mb-3'>
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Label>Handler Name</Form.Label>
                        {extraStation.station_code ? <Button variant="contained" className="p-0 add_btn" onClick={() => addressModalOpen('station')}>
                            + Add New Handler
                        </Button>
                            : ''}
                    </div>
                    <Select
                        options={stationHandler?.map(handler => ({
                            value: handler?.id,
                            label: handler?.company_name,
                            email: handler?.handler_email_id,
                            address: handler?.address,
                            number: handler?.handler_phone_no,
                            id: handler?.id,
                            hoid: handler?.handler_org_id,
                        }))}
                        onChange={(selected) => {

                            setSelectedStationHandler(selected);
                            setExtraStation(prevFormData => {
                                const newFormData = { ...prevFormData, station_handler_id: selected.value };

                                return newFormData;
                            });
                        }}
                        placeholder="Handler Name"
                        className='autoslct w-100 p-0'
                        name="station_handler_id"
                        // value={handlerNames.find(option => option.value === (selectedHandler ? selectedHandler.value : ''))}
                        value={selectedStationHandler ? { value: selectedStationHandler.value, label: selectedStationHandler.label } : ''}
                        isDisabled={!stationHandler.length}
                    />
                </Form.Group>
            </CommonModal>
            {addressShow && <AddStationHandler propData={sendHandler} modalClose={() => setAddressShow(false)} modalSubmit={handleModalSubmit} />}
        </>
    )
}

export default OvDetails